export interface IHttpRequest {
  url: string;
}

export interface IHttpMapGet extends IHttpRequest {
  user_id?: string;
}

export interface ISidebarConfig {
  customer: string;
  customerCategory: string;
}
